import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from './constants';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, ThemeProvider, createTheme, Typography  } from '@mui/material';
import { useAuth } from './AuthContext';
import './SimpleLogin.css'; // Import CSS file for styling


const theme = createTheme({
  palette: {
    primary: {
      main: '#000000', // Black color
    },
  },
});



const SimpleLogin = () => {
  const [usernameInput, setUsernameInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, handleSimpleLogin } = useAuth();
  const navigate = useNavigate();

  

  const handleLogin = async () => {
    setIsLoading(true);
    setError('');
    
    try {
      const response = await axios.post(
        `${API_URL}/login`,
        {
          username: usernameInput,
          password: password
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      if (response.status === 200) {
        console.log('Login successful:', response.data);
        setError('');
        handleSimpleLogin({
          projectKey: response.data.project_key,
          username: usernameInput
        });
        // Redirect or perform further actions upon successful login
        navigate('/'+usernameInput+'/product-detail');
      } else {
        throw new Error(response.data.detail);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent default form submission behavior
    handleLogin(); // Call handleLogin when the form is submitted
  };

  return (
    <div>


<ThemeProvider theme={theme}>
<div>
      {isAuthenticated ? (
        <div>
          <Typography variant="h5" gutterBottom>Welcome!</Typography>
          <Typography>You are successfully logged in.</Typography>
        </div>
      ) : (
        <div className="login-container">
          <h2>Login</h2>
          <div className="input-container">
            <TextField
              label="Username"
              variant="outlined"
              value={usernameInput}
              onChange={(e) => setUsernameInput(e.target.value)}
            />
          </div>
          <div className="input-container">
            <TextField
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </Button>
          {error && <p className="error-message">{error}</p>}
        </div>
      )}
    </div>
   
   </ThemeProvider>
    </div>
    
   
          
    
  );
};

export default SimpleLogin;